"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AspectRatios_1 = __importDefault(require("../entity/FacetParts/AspectRatios"));
const defaultValue = [
    { value: '16:9', count: 31 },
    { value: '1:1', count: 2 },
    { value: '9:16', count: 1 },
];
exports.generateAspectRatioEntity = (jsons = defaultValue) => AspectRatios_1.default.fromJSON({
    buckets: jsons,
});
